<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <draggable v-model="columnData">
                <div v-for="item in columnData" :key="item.ColumnCode">
                    <div class="set-item">
                        <el-checkbox :checked="item.IsSearch" v-model="item.IsSearch" border class="item-canset"></el-checkbox>
                        <el-tag class="item-cname2" effect="plain">
                            {{ item.Separator }}
                        </el-tag>
                    </div>
                </div>
            </draggable>

            <div v-if="separatorObj.IsSeparator" class="item-sep">
                <el-checkbox disabled :checked="separatorObj.IsSearch" border class="item-canset"></el-checkbox>
                <el-input placeholder="请输入分隔符" v-model="separatorObj.Separator" show-word-limit maxlength="1">
                    <template slot="prepend">分隔符</template>
                </el-input>
            </div>
            <i v-if="separatorObj.IsSeparator" class="el-icon-info sep-info"
                >当前分割符为“{{ separatorObj.Separator == ' ' ? separatorObj.Separator + '(空格)' : separatorObj.Separator }}” 分隔符以空格示例：奥迪 A1 1.4T 2018</i
            >
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
            <el-button class="search-btn" type="warning" @click="restoreDefault">恢复默认</el-button>
            <el-button class="search-btn" @click="closeDialog(false)">取消</el-button>
            <el-button class="search-btn btn-primary" @click="submit">保存设置</el-button>
        </div>
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
    </div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    name: '',
    components: {
        draggable
    },
    data() {
        return {
            columnData: [],
            loading: false,
            separatorObj: {},
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 50,
                // 总数量
                _totalCount: 0
            }
        };
    },
    created() {
        // 阻止火狐的默认拖拽事件
        document.body.ondrop = event => {
            event.preventDefault();
            event.stopPropagation();
        };
    },
    mounted() {
        this.getSetsData();
    },
    methods: {
        getSetsData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEntpAutoSeriesSets',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        let separatorIdx = data.findIndex(f => f.IsSeparator);
                        // 判断是否有分隔符
                        if (separatorIdx > -1) {
                            let sArr = data.splice(separatorIdx, 1);
                            this.separatorObj = sArr[0];
                        }
                        this.columnData = data;
                    }
                    this.loading = false;
                });
        },
        submit() {
            let canSunbmit = false;
            this.columnData.forEach(item => {
                if (item.IsSearch) {
                    canSunbmit = true;
                    return;
                }
            });

            if (!canSunbmit) {
                this.$util.warningMsg('通用车型必须有一项或多项进行生成');
                return;
            }
            if (this.separatorObj.Separator === ',') {
                this.$util.warningMsg('分隔符不可以使用 ","');
                return;
            }

            this.$confirm('您确定要提交通用车型设置吗？提交后则会重新生成通用车型，可能会耗时比较长，请耐心等候', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '不了',
                type: 'warning',
                center: false
            })
                .then(() => {
                    this.loading = true;
                    // 重新排序
                    let dataSort = this.columnData.map((m, i) => {
                        return Object.assign(m, { SortNum: i + 1 });
                    });
                    if (this.separatorObj.IsSeparator) {
                        dataSort.push(this.separatorObj);
                    }
                    this.$util
                        .axiosPost({
                            url: '/api/EntpGoods/SubmitAutoSeriesSets',
                            data: { JointSetsData: dataSort },
                            hideLoading: true
                        })
                        .then(res => {
                            //this.$util.successMsg(res.errmsg);

                            this.searchApParams = {
                                _visible: true,
                                _percentage: 0,
                                _limit: this.searchApParams._limit,
                                _totalCount: res.data,
                                limit: this.searchApParams._limit,
                                page: 1
                            };
                            if (res.data > 0) this.loopSearch();

                            //this.closeDialog(true);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {});
        },
        restoreDefault() {
            this.$confirm('您确定要重置通用车型设置吗？重置后则会重新生成通用车型，可能会耗时比较长，请耐心等候', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '不了',
                type: 'warning',
                center: false
            })
                .then(() => {
                    this.loading = true;
                    this.$util
                        .axiosPost({
                            url: `/api/EntpGoods/RestoreDefaultAutoSeriesSets`,
                            hideLoading: true
                        })
                        .then(res => {
                            // this.$util.successMsg(res.errmsg);
                            // this.closeDialog();
                            this.searchApParams = {
                                _visible: true,
                                _percentage: 0,
                                _limit: this.searchApParams._limit,
                                _totalCount: res.data,
                                limit: this.searchApParams._limit,
                                page: 1
                            };
                            if (res.data > 0) this.loopSearch();
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {});
        },
        // 开始循环
        async loopSearch() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/BuildGoodsAutoSeriesData',
                    data: {
                        limit: this.searchApParams.limit,
                        page: this.searchApParams.page
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
                        this.searchApParams.page += 1;
                        let _stop =
                            this.searchApParams.page * this.searchApParams.limit > this.searchApParams._totalCount &&
                            (this.searchApParams.page - 1) * this.searchApParams.limit >= this.searchApParams._totalCount;

                        if (_stop) {
                            this.searchApParams._percentage = 100;
                            this.searchApParams._visible = false;
                            this.closeDialog();
                        } else {
                            this.loopSearch();
                        }
                    }
                });
        },
        closeDialog() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scope>
.set-content {
    display: flex;
    flex-direction: column;

    .set-item {
        display: flex;
        flex-direction: row;
        height: 40px;

        .item-canset {
            width: 7%;
            border-radius: 5px 0 0 5px;
        }

        .item-cname2 {
            width: 93% !important;
        }
    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-input__inner {
        border-radius: 0;
    }
    .el-button {
        border-radius: 0;
    }
    .el-tag {
        height: 100%;
        width: 100%;
        border-radius: 0 5px 5px 0;
        font-size: 14px;
        line-height: 35px;
    }
    .item-sep {
        display: flex;
        flex-direction: row;
        height: 40px;
        margin-top: 30px;

        .item-canset {
            width: 7%;
            border-radius: 5px 0 0 5px;
        }

        .el-input__inner {
            border-radius: 0 5px 5px 0;
        }
    }
    .sep-info {
        margin-top: 10px;
        color: rgb(155, 153, 153);
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
</style>
